// extracted by mini-css-extract-plugin
module.exports = {"specialisms":"styles_specialisms__S1oeq","specialisms__content":"styles_specialisms__content__JPpXS","pulse":"styles_pulse__VQzk_","jump":"styles_jump__4unSv"};